import React from "react";
import "./template-preview.css"

export const HeaderPreview = ({ header }) => {
    const { selectedHeaderType, imageMaxHeight, imageUrl, videoUrl } = header;
    const lowerCaseType = selectedHeaderType;
    const mediaStyle = { maxHeight: imageMaxHeight };

    if (lowerCaseType === "image") {
        const source = imageUrl || "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2Fph_image.png?alt=media&token=b42e2452-09c4-4076-9956-15520363da4b";
        return <img className="header-preview" alt="En-tête de la campagne" src={source} style={mediaStyle} />;
    }

    if (lowerCaseType === "video") {
        const source = videoUrl || "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2Fph_video.png?alt=media&token=33b76a14-ff16-41b0-acfb-48b1159ba993";
        if (videoUrl) {
            return <video className="header-preview" src={source} style={mediaStyle} />;
        }
        return <img className="header-preview" alt="En-tête de la campagne" src={source} style={mediaStyle} />;
    }

    return null;
};
